<div class='toastStack'>
  @for (toast of (this.toastService.toasts | async); track toast.id) {
    <div class='toastCard'>
      <span class='toastMessage'>{{ toast.message }}</span>
      <button type='button' class='toastClose' (click)='this.dismiss(toast.id)' aria-label='Dismiss'>&times;</button>
    </div>
  }
</div>
